import { isEmpty } from 'lodash';
import { ACCESS_TOKEN } from '../common/const';
const USER_INFO = 'userInfo';


const parse = JSON.parse;
const stringify = JSON.stringify;

const Auth = {
  /**
   * Remove an item from the used storage
   * @param  {String} key [description]
   */
  clear(key) {
    if (sessionStorage && sessionStorage.getItem(key)) {
      return sessionStorage.removeItem(key);
    }

    return null;
  },

  clearAppStorage() {
    if (sessionStorage) {
      sessionStorage.clear();
    }

  },

  clearToken(tokenKey = ACCESS_TOKEN) {
    return Auth.clear(tokenKey);
  },

  clearUserInfo(userInfo = USER_INFO) {
    return Auth.clear(userInfo);
  },

  /**
   * Returns data from storage
   * @param  {String} key Item to get from the storage
   * @return {String|Object}     Data from the storage
   */
  get(key) {
    if (sessionStorage) {
      let val= sessionStorage.getItem(key);
      return val?parse(val) : null;
    }

    return null;
  },

  getToken(tokenKey = ACCESS_TOKEN) {
    return Auth.get(tokenKey);
  },

  getUserInfo(userInfo = USER_INFO) {
    return Auth.get(userInfo);

  },

  /**
   * Set data in storage
   * @param {String|Object}  value    The data to store
   * @param {String}  key
   * @param {Boolean} issessionStorage  Defines if we need to store in sessionStorage or sessionStorage
   */
  set(key, value, issessionStorage) {
    if (isEmpty(value)) {
      return null;
    }

    if (issessionStorage && sessionStorage) {
      return sessionStorage.setItem(key, stringify(value));
    }
    if (sessionStorage) {
      return sessionStorage.setItem(key, stringify(value));
    }

    return null;
  },

  setToken(value = '', tokenKey = ACCESS_TOKEN, issessionStorage = false) {
    return Auth.set(tokenKey, value, issessionStorage);
  },

  setUserInfo(value = '', userInfo = USER_INFO, issessionStorage = false) {
    return Auth.set(userInfo, value, issessionStorage);
  },
};

export default Auth;
